export default "__VITE_ASSET__Zz7o_7NeIMnYzYvY1rh_AA__"